// Formato de fecha/hora en zona horaria de Bogotá (America/Bogota).
// La hora se muestra en formato 12h con am/pm y solo horas:minutos.
const TZ = 'America/Bogota';

const fmtHora = new Intl.DateTimeFormat('es-CO', {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
  timeZone: TZ,
});

const fmtFecha = new Intl.DateTimeFormat('es-CO', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  timeZone: TZ,
});

export function horaBogota(iso: string): string {
  if (!iso) return '';
  return fmtHora.format(new Date(iso));
}

export function fechaBogota(iso: string): string {
  if (!iso) return '';
  return fmtFecha.format(new Date(iso));
}
